var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pc"}},[_c('el-container',[_c('el-header',{attrs:{"height":"36px"}},[_c('vheader')],1),_vm._v(" "),_c('el-divider'),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('navmenu')],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5945746a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/PC.vue
// module id = null
// module chunks = 